export default class IframeTab {
  constructor(element) {
    this.el = element
    this.tabs = this.el.querySelectorAll("button");
    this.frameContainer = this.el.querySelector("[data-framecontainer]");
    
    this.loadFrame = this.loadFrame.bind(this);
    
    this.init();
  }

  init() {
    if (this.tabs){
      this.tabs.forEach(tab => {
        tab.addEventListener('click', e =>{
          this.loadFrame(tab.dataset.url, tab.dataset.id, tab.dataset.path)
        })
      });
    }
  }

  loadFrame(url, id, path){
   let content = `
    <iframe id="${id}" name="${id}" src="${url}" width="100%" frameborder="0" scrolling="no" onload="dmsLoadMessageHandler('${id}', '${path}');"></iframe>
    <script style="display: none;">
      dmsLoadMessageHandler("${id}", "");
      if (0 == -1) {
          console.error('SelfServiceHelpers.StartWorkFlow returned -1. This is probably caused by the specified workflowTypeId and caseTypeId not constituting a valid self service workflow.\n'
              + 'Case Type Id: ' + 0, '\n'
              + 'Workflow Type Id: ' + 0)
      }
    </script>
    `
   
    this.frameContainer.innerHTML=content;

  }
}
